export default __webpack_public_path__ + "static/media/chirpstackArchitecture.ae6247de.png";